import type { ComponentType } from 'react'

interface PageTitleProps {
  icon: ComponentType<{ className?: string }>
  title: string
  subtitle?: string
  children?: React.ReactNode
}

export function PageTitle({ icon: Icon, title, subtitle, children }: PageTitleProps) {
  return (
    <div className="mb-6 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-primary to-primary/70 text-white shadow-md">
          <Icon className="h-6 w-6" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-neutral-900">{title}</h1>
          {subtitle && (
            <p className="mt-0.5 text-sm text-neutral-500">{subtitle}</p>
          )}
        </div>
      </div>
      {children}
    </div>
  )
}
